// Tiny screen-state machine. No framework; each screen is a render function
// that gets (state, actions) and returns the DOM. Transitions are handled
// by swapping the contents of #app.

import { renderIntro } from './screens/intro.js';
import { renderModem } from './screens/modem.js';
import { renderGateway } from './screens/gateway.js';
import { renderAp } from './screens/ap.js';
import { renderDone } from './screens/done.js';

export const SCREENS = ['intro', 'modem', 'gateway', 'ap', 'done'];

const RENDERERS = {
  intro: renderIntro,
  modem: renderModem,
  gateway: renderGateway,
  ap: renderAp,
  done: renderDone,
};

export function createRouter({ root, initialState, actions }) {
  let state = initialState;

  function setState(patch) {
    state = typeof patch === 'function' ? patch(state) : { ...state, ...patch };
    render();
  }

  function goto(screen) {
    setState({ screen });
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }

  function render() {
    const renderer = RENDERERS[state.screen];
    if (!renderer) {
      const err = document.createElement('p');
      err.className = 'session-error';
      err.textContent = `Unknown screen: ${state.screen}`;
      root.replaceChildren(err);
      return;
    }
    const node = renderer(state, {
      ...actions,
      goto,
      setState,
      getState: () => state,
    });
    root.replaceChildren(node);
  }

  return { setState, goto, render, getState: () => state };
}
